var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgModalClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 34.725,
    height: 34.725,
    viewBox: "0 0 34.725 34.725",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16101",
    "data-name": "Rectangle 16101",
    width: 24.54,
    height: 24.568,
    fill: "#9d9d9d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15533",
    "data-name": "Group 15533",
    transform: "translate(17.372) rotate(45)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15411",
    "data-name": "Group 15411",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41212",
    "data-name": "Path 41212",
    d: "M18.583,14.894H15.152c-.27,0-.271,0-.271.278,0,2.237,0,4.474,0,6.71a2.52,2.52,0,0,1-1.573,2.462,2.609,2.609,0,0,1-3.532-1.6,3.2,3.2,0,0,1-.12-.916c-.01-2.231-.006-4.462-.006-6.694,0-.242,0-.24-.242-.24-2.276,0-4.552,0-6.827,0a2.616,2.616,0,0,1-.932-5.05,2.9,2.9,0,0,1,.973-.172c2.276-.014,4.551-.007,6.827-.007.2,0,.205-.005.2-.229q0-3.381,0-6.761a2.565,2.565,0,0,1,.843-1.99A2.617,2.617,0,0,1,14.787,1.93a3,3,0,0,1,.09.751c.006,2.248,0,4.5,0,6.744,0,.238,0,.238.247.238,2.214,0,4.428,0,6.641,0a2.7,2.7,0,0,1,1.782.558,2.5,2.5,0,0,1,.959,2.425,2.487,2.487,0,0,1-1.961,2.176,2.728,2.728,0,0,1-.686.071c-1.093.007-2.186,0-3.278,0",
    transform: "translate(0 0)",
    fill: "#9d9d9d"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalClose);
export default __webpack_public_path__ + "static/media/modal-close.a679e00effa91a4cc7b142e2873d0476.svg";
export { ForwardRef as ReactComponent };